import { Component, Inject, NgZone, ViewChild, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { InteractionType, AuthenticationResult, RedirectRequest, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { UserDetail, UserService } from './modules/shared/user.service';
import { filter, Subject, Subscription, take, takeUntil } from 'rxjs';
import * as fromModel from './modules/shared/models';
import { HttpService } from './modules/shared/http.service';
import { Utils } from './modules/shared/utils';
import { Constant } from './modules/shared/constants';
// Corrected import path or ensure the file exists
import * as fromModels from './modules/shared/models';
import { MatMenuTrigger } from '@angular/material/menu';
import { InitService } from './modules/shared/init.service';
import { AdvisorService } from './modules/shared/advisors-tree-filter/advisor.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly _destroying$ = new Subject<void>();
  isFirstTimeLoggedin = false;
  private hasSessionBootstrapped = false;
  private sessionBootstrapInProgress = false;
  private lastAdvisorRequestKey = '';
  loggedIn: boolean = false;
  _urlSub?: Subscription;
  user: UserDetail | undefined;

  loggedInUser: UserDetail | undefined;
  simRole: fromModels.USERROLE | any;
  orgRole: fromModels.USERROLE | any;
  tempRole: fromModels.USERROLE | any;
  isVisibleRoleSelection=true;
  isDivisionSelection=true;
  showProgress = false;
  runMessage:string='';
  isUnauthorizedRoute = false;
  repIds: string[]=[];
  @ViewChild('advMenuTrigger') advMenuTrigger: MatMenuTrigger | undefined;
  advTree: fromModels.TodoItemNode[] = [];
    userSub?: Subscription;
  


  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private router: Router,
    private userService: UserService,
   
    private _advisor:AdvisorService,
    private ngZone: NgZone,
  
  ) {

    this.isUnauthorizedRoute = this.checkUnauthorizedRoute(this.router.url);

    this._urlSub = router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isUnauthorizedRoute = this.checkUnauthorizedRoute(event.urlAfterRedirects || event.url);
      }
    });
  }


  async ngOnInit() {
    this.userService.traceMsg("******** Supervision - App - Init ********");
    // Bail out when running inside MSAL's internal hidden auth iframe OR popup auth window.
    // MsalRedirectComponent bootstrapped in app.module handles those flows.
    if (window !== window.parent || window.opener) {
      return;
    }

    // Initialize MSAL first before any other operations
    try {
      console.log('Initializing MSAL instance...');
      await this.authService.instance.initialize();
      console.log('MSAL instance initialized successfully');
    } catch (error) {
      console.error('MSAL initialization error:', error);
      return; // Exit early if MSAL can't be initialized
    }

    // MSAL's redirect/broadcast streams run outside Angular's zone; re-enter it explicitly
    // so change detection actually runs after these auth events update component state.
    this.authService.handleRedirectObservable()
      .pipe(takeUntil(this._destroying$))
      .subscribe({
        next: (result: AuthenticationResult | null) => {
          this.ngZone.run(() => {
            if (result?.account) {
              this.authService.instance.setActiveAccount(result.account);
              this.afterAuthSuccess(result);
            }
          });
        },
        error: (error) => {
          this.ngZone.run(() => console.error('MSAL redirect error:', error));
        }
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.LOGIN_SUCCESS ||
          msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          msg.eventType === EventType.LOGOUT_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        this.ngZone.run(() => {
          if (result.eventType === EventType.LOGOUT_SUCCESS) {
            this.loggedIn = false;
            this.isFirstTimeLoggedin = false;
            this.hasSessionBootstrapped = false;
            this.sessionBootstrapInProgress = false;
            this.lastAdvisorRequestKey = '';
            this.user = undefined;
            this.loggedInUser = undefined;
              this.orgRole = undefined;
              this.simRole = undefined;
              this.tempRole = undefined;
            sessionStorage.clear();
            return;
          }

          const payload = result.payload as AuthenticationResult;
          if (payload?.account) {
            this.authService.instance.setActiveAccount(payload.account);
          }
          this.afterAuthSuccess(payload);
        });
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        take(1),
        takeUntil(this._destroying$)
      )
      .subscribe(async () => {
        const active = this.authService.instance.getActiveAccount();
        if (!active) {
          const accounts = this.authService.instance.getAllAccounts();
          if (accounts.length > 0) {
            this.authService.instance.setActiveAccount(accounts[0]);
            this.ngZone.run(() => this.loggedIn = true);
            void this.bootstrapUserSessionOnce();
            return;
          }
          this.ngZone.run(() => this.loggedIn = false);
          this.login();
          return;
        }
        this.ngZone.run(() => this.loggedIn = true);
        void this.bootstrapUserSessionOnce();
      });

    this.userSub = this.userService.userSubject.subscribe((user) => {

      if (user) {
        this.ngZone.run(() => {
          this.loggedInUser = user;

          if (!this.orgRole) {
            this.orgRole = user.role;
          }

          this.simRole = user.role;
          // Blank on login; retain the selection once a role has been applied.
          this.tempRole = user.roleApplied ? user.role : undefined;
        });
      }
    });
  }

        
divisionPopulation(){
  if (!this.loggedInUser) {
    return;
  }

  const userId = this.loggedInUser.userid || '';
  const advisorUserId = this.loggedInUser.role === fromModels.USERROLE.BM
    ? userId
    : '';
  const isFaOnly = this.loggedInUser.role === fromModels.USERROLE.FA;
  const advisorRequestKey = `${this.loggedInUser.role}|${userId}|${isFaOnly}`;
  if (this.lastAdvisorRequestKey === advisorRequestKey) {
    return;
  }
  this.lastAdvisorRequestKey = advisorRequestKey;

  this._advisor
  .getAdvisors(
    advisorUserId,
    isFaOnly
  )
  .subscribe({
    next: (adv: fromModels.AdvisorHirerarchy) => {
      if (adv && adv.regions && adv.regions.length) {
        this.prepareAdvisorsTree(adv);
      }
    },
    error: (err) => {
      this.lastAdvisorRequestKey = '';
      this.userService.traceMsg(
        'PeriodicClientReview -> Error getting advisors data.',
        err,
        'Error'
      );
    },
  });
}

get showUserSel() {
    if (this.isUnauthorizedRoute) {
      return false;
    }

    if (Constant.config.env === 'QA' || Constant.config.env === 'DEV') {
      return (
        this.orgRole !== fromModels.USERROLE.FA &&
        this.orgRole !== fromModels.USERROLE.BM
      );
    } else if (Constant.config.env === 'PROD') {
      return this.orgRole === fromModels.USERROLE.SUPER;
    } else {
      return false;
    }
  }

  // Mirrors the /admin route's allowedRoles restriction (see app-routing.module.ts).
  get showAdminLink() {
    return this.loggedInUser?.role === fromModels.USERROLE.SUPERVISION;
  }

  get isAdminRoute(): boolean {
    return (this.router.url || '').toLowerCase().includes('/admin');
  }

  private checkUnauthorizedRoute(url: string | undefined): boolean {
    const normalized = (url || '').toLowerCase();
    return normalized.includes('/unauthorized') || normalized.includes('#/unauthorized');
  }


    private prepareAdvisorsTree(adv: any) {
      let advisorsTreeData: any[] = [];
      let id = 1;
      let code = '0.1';
      this.advTree = [];
      //regions
      adv.regions.forEach((r: any) => {
        let region = {
          text: r.regName,
          code: code.toString(),
          isChecked: false,
          id: 'R' + id.toString(),
          color: '#004377',
        };
        advisorsTreeData.push(region);
        id++;
  
        //hubs
        r.hubs.forEach((h: any, hi: any) => {
          let hub = {
            text: h.hubName,
            code: `${code.toString()}.${hi + 1}`,
            isChecked: false,
            id: 'H' + id.toString(),
            color: '#5c60b7',
          };
          advisorsTreeData.push(hub);
          id++;
  
          //teams
          h.teams.forEach((t: any, ti: any) => {
            let team = {
              text: t.teamName,
              code: `${hub.code}.${ti + 1}`,
              isChecked: false,
              id: 'T' + id.toString(),
              color: '#8A39E1',
            };
            advisorsTreeData.push(team);
            id++;
  
            //advisors
            t.advisors.forEach((a: any, ai: any) => {
              let advisor = {
                text: `${a.repId} - ${a.repName}`,
                code: `${team.code}.${ai + 1}`,
                isChecked: false,
                id: a.repId,
                color: 'black',
              };
              advisorsTreeData.push(advisor);
              id++;
            });
          });
        });
        code = (Number(code) + 0.1).toFixed(1);
      });
      this.advTree = advisorsTreeData;
    }

    closeAdvTree() {
      if (this.advMenuTrigger) {
        this.advMenuTrigger.closeMenu();
      }
    }

    advListChanged(_repIds: string[]) {
      this.repIds = _repIds;
      this.userService.repIds$.next(_repIds);
      this.closeAdvTree();
    }


      ngOnDestroy() {
       // this._urlSub?.unsubscribe();
        this._destroying$.next(undefined);
        this._destroying$.complete();
      }
    
      login() {
        const redirectRequest: RedirectRequest = {
          scopes: Constant.config.scopes
        };
        this.authService.loginRedirect(redirectRequest);
      }

  private afterAuthSuccess(payload: AuthenticationResult) {
    if (!this.isFirstTimeLoggedin) {
      this.isFirstTimeLoggedin = true;
      
      if (payload.account) {
        this.authService.instance.setActiveAccount(payload.account);
        console.log('Active account set:', payload.account);
      }
      
      // MSAL v6: idToken lives on the account object, not in localStorage.
      const idToken = this.getIdToken();
      if (idToken) {
        sessionStorage.setItem('msal.idtoken', idToken);
        this.userService.traceMsg("Supervision UI: idtoken set from account");
      }
    }

    void this.bootstrapUserSessionOnce();
    this.loggedIn = true;
  }

  getIdToken(): string {
    const account = this.authService.instance.getActiveAccount()
      ?? this.authService.instance.getAllAccounts()[0];
    return account?.idToken ?? '';
  }

  getIdTokenClaims(): Record<string, unknown> | null {
    const account = this.authService.instance.getActiveAccount()
      ?? this.authService.instance.getAllAccounts()[0];
    return (account?.idTokenClaims as Record<string, unknown>) ?? null;
  }

  private async bootstrapUserSessionOnce(): Promise<void> {
    if (this.hasSessionBootstrapped || this.sessionBootstrapInProgress) {
      return;
    }

    this.sessionBootstrapInProgress = true;
    const user = await this.userService.getUserNameFromSession();
    try {
      if (user) {
        this.user = user;
        this.hasSessionBootstrapped = true;
        // Division/advisor tree is independent of showUserSel; always populate it.
        this.divisionPopulation();
      }
    } finally {
      this.sessionBootstrapInProgress = false;
    }
    // login() is handled by the inProgress$ subscriber when user is null
  }

      logout() {
        console.log('Logging out user...');
        this.authService.logoutPopup().subscribe({
          next: () => {
            console.log('Logout successful');
            this.loggedIn = false;
            this.isFirstTimeLoggedin = false;
            this.user = undefined;
            this.loggedInUser = undefined;
              this.orgRole = undefined;
              this.simRole = undefined;
              this.tempRole = undefined;
            sessionStorage.clear();
          },
          error: (error) => {
            console.error('Logout error:', error);
          }
        });
      }
    
    
    
    
    
      //// fOR ui

      changeUser() {
        this.simRole = this.tempRole;
        this.userService.setActiveRole(this.simRole as fromModels.USERROLE);

        const currentUrl = (this.router.url || '').toLowerCase();
        if (currentUrl.includes('/report')) {
          this.router.navigate(['/home']);
        }
      }
    
}
